<script>
/**
 * Xero Not Connected Screen
 * @version 1.0.0
 * @since
 */

import EmptyState from '@/views/common/empty-state';
import EzButton from '@/components/ui/Button/EzButton';
import EzConfirmationModal from '@/components/ui/Modal/EzConfirmationModal';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    EmptyState,
    EzButton,
    EzConfirmationModal,
  },
  computed: {
    ...mapGetters('entities/users', ['isVenueXeroConnected']),
    venueId() { return this.$route.params.id; },
    isXeroConnected() { return this.isVenueXeroConnected(this.venueId); },
    platformName() {
      return process.env.VUE_APP_PLATFORM_TITLE;
    },
  },
  methods: {
    ...mapActions('xero', ['xeroAuthorize']),
    ...mapActions('entities/venues', ['fetchPlatformVenue']),
    ...mapActions('entities/users', ['initVenue']),
    confirmXeroConnection() {
      this.xeroAuthorize({
        route: 'venue-xero-setup',
        state: this.venueId,
      });
    },
    redirectToSettings() {
      if (this.isXeroConnected) {
        this.$router.replace({
          name: 'venue-xero-account',
          params: {
            flash: {
              title: 'You are already connected to Xero.',
              type: 'success',
            },
          },
        });
      }
    },
  },
  async created() {
    await this.fetchPlatformVenue(this.venueId);
    await this.initVenue();
    await this.redirectToSettings();
  },
};
</script>
<template>
  <div class="not-connected">
    <empty-state>
      <template #badge>
        <img src="@/assets/xero-empty-state.svg" alt="Xero" width="160" height="138">
      </template>
      <template #title>Connect your Xero account</template>
      <template #info>Connect your Xero account to be able to sync your Contacts on
        Xero with your {{ platformName }} account.</template>

      <div class="mt-16">
        <ez-button type="link" key="connectXero" v-open="'xeroConnectModal'" aria-label="Connect to Xero">
          <img src="@/assets/xero-connect-btn.svg" alt="Connect to Xero" role="presentation" />
        </ez-button>
      </div>
    </empty-state>

    <ez-confirmation-modal ref="xeroConnectModal" icon="question">
      <template #title>{{ $t('xero.integrations.confirmationModalTitle') }}</template>
      <template #content>
        <div class="xero-description"
             v-html="$t('xero.integrations.confirmationModalVenueContent', { platform: platformName })"/>
      </template>
      <template #footer>
        <ez-button type="link" v-close="'xeroConnectModal'">
          {{ $t('global.actions.cancel') }}
        </ez-button>
        <ez-button class="ml-12" @click="confirmXeroConnection">
          {{ $t('global.actions.confirm') }}
        </ez-button>
      </template>
    </ez-confirmation-modal>
  </div>
</template>
<style lang="scss" scoped>
.not-connected { padding-top: 80px; }
</style>
